import React from "react";
import Button from "../../atoms/button/button";

// Styles //
import "./formResult.scss";

interface FormResultProps {
    image: any;
    title: string;
    titleDescription?: any;
    description?: any;
    fixedDescription?: any;
    titleButton: string;
    buttonUrl: string;
    self?: boolean;
    onClickButton?: VoidFunction;
}

const FormResult = (props:FormResultProps) => {
    const {
        image,
        title,
        titleDescription,
        description,
        fixedDescription,
        titleButton,
        buttonUrl,
        self = false,
        onClickButton
    }= props;

    return (
        <div className={`m-form-result`}>
            <img className="m-form-result__image" src={image.file.url} alt={image.description}/>
            <h1 className="m-form-result__title">{title}</h1>
            {titleDescription && <p className="m-form-result__title-description">{titleDescription}</p>}
            {description && <p className="m-form-result__description">{description}</p>}
            {fixedDescription &&
                <div className="m-form-result__fixed-description">
                    {fixedDescription}
                </div>
            }
            <Button
                type="link"
                text={titleButton}
                classname={`a-button__magenta`}
                href={buttonUrl}
                isDisabled={false}
                self={self}
                onClickAction={onClickButton}
            />
        </div>
    );
};

export default FormResult;
